module.exports = __webpack_public_path__ + "a15e075b29fc0e93af3d677f830afe95.jpg";